import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import TierConsumerReduxModule from '../../Tier/redux/consumer/ModuleLoadable';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import SubscribeVariant from './variants/Subscribe';
import SubscribedVariant from './variants/Subscribed';
import ViewVariant from './variants/View';
import DisabledVariant from './variants/Disabled';
import s from './SubscribeButton.scss';
const SubscribeButton = ({ tier , tier: { tier: { isUserSubscribed , canUserSubscribe  } = {}  } , type , withPrice , showUnsubAsView , className , href , size , onSubscribe , reduxReady , matureFilterOverridden , matureFilterDisabled  })=>{
    const { showBlocked  } = useDeviationMatureFilter(tier);
    const waitingAction = useRef();
    useEffect(()=>{
        if (reduxReady && waitingAction.current) {
            waitingAction.current();
            waitingAction.current = undefined;
        }
    }, [
        reduxReady
    ]);
    // TODO: this (or the ds button itself) really needs a focus-visible ring
    const renderViewVariant = ()=>/*#__PURE__*/ React.createElement(ViewVariant, {
            tier: tier,
            className: cn(className, s['centered']),
            size: size
        });
    const renderSubscribeVariant = ()=>/*#__PURE__*/ React.createElement(SubscribeVariant, {
            tier: tier,
            className: className,
            withPrice: withPrice,
            href: href,
            size: size,
            onSubscribe: (t)=>{
                if (!reduxReady) {
                    waitingAction.current = ()=>{
                        onSubscribe && onSubscribe(t);
                    };
                    return;
                }
                onSubscribe && onSubscribe(t);
            }
        });
    const renderSubscribedVariant = ()=>/*#__PURE__*/ React.createElement(SubscribedVariant, {
            tier: tier,
            className: cn(className, s['centered'], s['unsubscribe-width']),
            href: href,
            size: size
        });
    const renderDisabledVariant = ()=>/*#__PURE__*/ React.createElement(DisabledVariant, {
            className: cn(className, s['centered']),
            size: size
        });
    let buttonElement;
    if (type) {
        switch(type){
            case 'view':
                buttonElement = renderViewVariant();
                break;
            case 'subscribe':
                buttonElement = renderSubscribeVariant();
                break;
            case 'subscribed':
                buttonElement = renderSubscribedVariant();
                break;
            case 'disabled':
                buttonElement = renderDisabledVariant();
                break;
            default:
                break;
        }
    } else {
        if (isUserSubscribed) {
            if (showUnsubAsView) {
                buttonElement = renderViewVariant();
            } else {
                buttonElement = renderSubscribedVariant();
            }
        } else if (showBlocked && !matureFilterDisabled && !matureFilterOverridden || !canUserSubscribe) {
            buttonElement = renderDisabledVariant();
        } else {
            buttonElement = renderSubscribeVariant();
        }
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null), buttonElement);
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
